import { useState } from "react";
import "./Testimonials.css";

const testimonials = [
  {
    name: "Praveen Mamidi.",
    rating: 5,
    text: "Excellent treatment and very friendly staff. The doctor explained everything clearly and made me feel comfortable throughout the procedure.",
    tag: "Dental Implant",
  },
  {
    name: "Rajesh.",
    rating: 5,
    text: "The doctor was very kind and explained the treatment clearly. The procedure was painless and the clinic was very clean. Highly recommended!",
    tag: "Root Canal",
  },
  {
    name: "Prameela.",
    rating: 5,
    text: "Excellent service and another experience. My root canal treatment was smooth and the doctor was extremely gentle. Will definitely visit again.",
    tag: "Cosmetic Dentistry",
  },
  {
    name: "Sri lakshmi.",
    rating: 5,
    text: "I was very anxious about my dental implant but the team made me feel so comfortable. The results are amazing — best decision I've made!",
    tag: "Dental Implant",
  },
];

export default function Testimonials() {
  const [active, setActive] = useState(0);

  return (
    <section className="testimonials">
      <div className="testimonials-inner">
        <div className="testi-header">
          <span className="section-tag">Patient Stories</span>
          <h2 className="section-title">What Our Patients Say</h2>
          <p className="section-subtitle">Real feedback from real patients — collected and verified.</p>
        </div>

        <div className="testi-grid">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className={`testi-card ${i === active ? "active" : ""}`}
              onClick={() => setActive(i)}
            >
              <div className="testi-tag">{t.tag}</div>
              <div className="testi-stars">
                {"★".repeat(t.rating)}
              </div>
              <p className="testi-text">"{t.text}"</p>
              <div className="testi-author">
                <div className="testi-avatar">{t.name[0]}</div>
                <span className="testi-name">{t.name}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="testi-rating-summary">
          <div className="rating-big">4.5+</div>
          <div>
            <div className="rating-stars">★★★★★</div>
            <div className="rating-sub">Based on 500+ reviews</div>
          </div>
        </div>
      </div>
    </section>
  );
}
